import { percentFormat } from '@/utils/hooks/format/useFormatNumber';

import type { ChartType } from '@/lib/analytics/charts/chart.type';
// Lib
import { SIZE_50 } from '@/lib/gridElements/size';
import { TIKTOK_BUSINESS } from '@/lib/socialProfile';

// Components
import { LineChart } from '@/components/composite/Charts/LineChart';

export const avgEngagementOnViewsHistoryConfig: ChartType<typeof LineChart> = {
    title: 'chart.tiktok.average_engagement_on_views_history',
    tooltip: 'chart.tiktok.tooltip_average_engagement_on_views_history',
    margin: { left: -10, right: 25 },
    name: {
        date: 'date',
        value: 'chart.tiktok.average_engagement_on_views_history_name'
    },
    id: 'average_engagement_on_views_history',
    social: TIKTOK_BUSINESS,
    color: {
        value: 'green'
    },
    valueFormat: { ...percentFormat, maximumFractionDigits: 4 },
    size: SIZE_50,
    type: 'chart',
    element: LineChart,
    dashboardEligibleNetworks: [TIKTOK_BUSINESS]
};
